// extracted by mini-css-extract-plugin
export default {"icon":"aTk5X"};